import React from "react"
import SocialLinks from "../../constants/socialLinks"
import logo from "../../assets/sc_mark.png"
import { Link } from "gatsby"

const Footer = () => {
  return (
    <footer class="bg-white text-sm bottom-0 w-full relative pt-10 scmd:pt-0">
      <div class="mx-auto">
        
        {/* Footer Legal, Contact & Social */}
        <div class="w-full flex flex-col">
          <div class="flex-1 mb-1 text-black text-center text-xs">
            <span>
              <Link to="/legal" className="pr-4 font-bold no-underline text-gray-600 hover:text-sc-secondary-dark-blue">Privacy & Legal</Link>
            </span>
          </div>
          <div class="flex-1 mb-1 text-black text-center">
            <p class="text-xs text-sc-secondary-light-blue capitalize font-normal">
              &copy; copyright {new Date().getFullYear()} StickChart, LLC. All rights reserved.
            </p> 
          </div>
        </div>
        {/* Footer Legl */}
        <div class="w-full flex flex-col scmd:flex-row py-1">
          
        </div>
        
        
      </div>
    </footer>
    )
}

export default Footer
